import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { environment } from '../environments/environment';
import * as Sentry from "@sentry/angular";
import { Integrations } from "@sentry/tracing";
import { SentryIonicErrorHandler } from "./sentry-error-handler.service";

/*
  Generated class for the MloggerProvider provider.

  See https://angular.io/docs/ts/latest/guide/dependency-injection.html
  for more info on providers and Angular 2 DI.
*/
export const Mlogger = {
  service: "sentry",
  severity: {
    debug2: -1,
    debug: 0,
    info: 1,
    warn: 2,
    error: 3,
    none: 4,
  },
  step: {
    start: 0,
    end: 99,
    log: 98
  },
  sampling: 1.0,
}

@Injectable({
  providedIn: 'root'
})
export class MloggerProvider {
  private service: string;
  private session: string;
  private apptag: string;
  private severity: number; //all logs equal or above this will get logged
  private sampling: number; //as of now, we will assume 1 -- avoid sampling
  private tz: string; //zone to be used while logging a time
  private flushinterval: number; //flush interval in seconds
  private logformat: string; //json

  constructor() {
    let startedAt = Date.now();
    this.severity = typeof environment.mloggerSeverity ? environment.mloggerSeverity : Mlogger.severity.info;
    this.tz = '+00:00';
    this.sampling = Mlogger.sampling;
    let endedAt = Date.now();
    let duration = endedAt - startedAt;
  }

  public log_init(service: string, apptag: string = 'mlogger', session: string, severity: number, sampling: number, flushinterval: number = 0, tz: string = '+00:00', params: any = {}) {

    if (service)
      this.service = service;
    if (apptag)
      this.apptag = apptag;
    if (session)
      this.session = session;
    if (typeof severity)
      this.severity = severity;
    if (tz)
      this.tz = tz;
    if (sampling)
      this.sampling = sampling;
    if (flushinterval)
      this.flushinterval = flushinterval;
    switch (service) {
      case 'sentry':

       // Sentry.init(params); // this is implemented in main.ts
        
        break;
      default:
        return throwError(service + ' service is not supported in mlogger provider.');
    }
    return true;
  }
  public log(severity: number, step: number, ts: String, user: string, module: String, ip: string, msg: string, msgdetails: string, params: any) {
    
    // TODO Perform parameter validation
    if (severity >= this.severity) {
      switch (this.service) {
        case 'sentry':
          /**Sentry start */
          this.log_flush();
          Sentry.configureScope(function (scope) {
            scope.setUser({ 'username': user });
            switch (severity) {
              case Mlogger.severity.debug2:
                scope.setLevel(Sentry.Severity.Debug);
                break;
              case Mlogger.severity.debug:
                scope.setLevel(Sentry.Severity.Debug);
                break;
              case Mlogger.severity.info:
                scope.setLevel(Sentry.Severity.Info);
                break;
              case Mlogger.severity.warn:
                scope.setLevel(Sentry.Severity.Warning);
                break;
              case Mlogger.severity.error:
                scope.setLevel(Sentry.Severity.Error);
                break;
              case Mlogger.severity.none:
                scope.setLevel(Sentry.Severity.Log);
                break;
              default:
                scope.setLevel(Sentry.Severity.Log);
            }
          });
          switch (step) {
            case Mlogger.step.start:
              Sentry.addBreadcrumb({
                type: this.apptag,
                level: Sentry.Severity.Info,
                event_id: '',
                category: this.apptag,
                message: typeof params && typeof params[0] && typeof params[0].message ? params[0].message : 'undefined',
                data: typeof params && typeof params[0] && typeof params[0].data ? params[0].data : {},
                timestamp: typeof params && typeof params[0] && typeof params[0].timestamp ? params[0].timestamp : 0,
              });
              Sentry.captureMessage(msg);
              break;
            case Mlogger.step.log:
              Sentry.addBreadcrumb({
                type: this.apptag,
                level: Sentry.Severity.Info,
                event_id: '',
                category: this.apptag,
                message: typeof params && typeof params.message ? params.message : 'undefined',
                data: typeof params && typeof params.data ? params.data : {},
                timestamp: typeof params && typeof params.timestamp ? params.timestamp : 0,
              });
              Sentry.captureMessage(msg);
              break;
            case Mlogger.step.end:
              let start = typeof params && typeof params[0] && typeof params[0].data ? params[0].data : {}
              Sentry.addBreadcrumb({
                type: this.apptag,
                level: Sentry.Severity.Info,
                event_id: '',
                category: this.apptag,
                message: typeof params && typeof params[0] && typeof params[0].message ? params[0].message : 'undefined',
                data: start,
                timestamp: typeof params && typeof params[0] && typeof params[0].timestamp ? params[0].timestamp : 0,
              });
              let end = typeof params && typeof params[1] && typeof params[1].data ? params[1].data : {};
              end.fn_start_time = start.fn_start_time;
              end.fn_exe_time = (((end.fn_end_time - end.fn_start_time) / 1000).toFixed(2)) + 's';
              Sentry.addBreadcrumb({
                type: this.apptag,
                level: Sentry.Severity.Info,
                event_id: '',
                category: this.apptag,
                message: typeof params && typeof params[1] && typeof params[1].message ? params[1].message : 'undefined',
                data: end,
                timestamp: typeof params && typeof params[1] && typeof params[1].timestamp ? params[1].timestamp : 0,
              });
              Sentry.captureMessage(msg + ' ' + end.fn_exe_time);
              break;
          }
          /**Sentry end */
          break;
        default:
          return throwError(this.service + ' service is not supported in mlogger provider.');
      }
    }
    return true;
  }

  // forced flush of logs, empty for sentry.io
  public log_flush() {
    switch (this.service) {
      case 'sentry':
        Sentry.configureScope(function (scope) {
          scope.clearBreadcrumbs();
        });
        break;
    }
  }
}
